import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SoothCard from "components/base/SoothCard";
import AccessibleIconButton from "components/base/AccessibleIconButton";

// Expects searchTerms: string[] | null
export default function KeySearchTermsCard({ searchTerms }) {
  // Show a skeleton loader while data is loading
  if (!searchTerms) {
    return (
      <SoothCard sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            mb: 1.5,
          }}
        >
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            Key Search Terms
          </Typography>
          <AccessibleIconButton
            size="small"
            sx={{ p: 0.5 }}
            title="Most common search terms that led readers to discover your content, helping understand reader intent."
            tooltipProps={{
              placement: "top",
            }}
          >
            <InfoOutlinedIcon fontSize="small" color="primary" />
          </AccessibleIconButton>
        </Box>
        <Skeleton variant="text" sx={{ fontSize: "1rem", mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: "1rem", mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: "1rem", mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      </SoothCard>
    );
  }

  return (
    <SoothCard
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 1,
        }}
      >
        <Typography component="div" variant="h4" sx={{ textAlign: "center" }}>
          Key Search Terms
        </Typography>
        <AccessibleIconButton
          size="small"
          sx={{ p: 0.5 }}
          aria-label="Most common search terms that led readers to discover your content, helping understand reader intent."
          tooltipProps={{
            placement: "top",
          }}
        >
          <InfoOutlinedIcon fontSize="small" color="primary" />
        </AccessibleIconButton>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto", // Add scroll if content overflows
        }}
      >
        {searchTerms.length > 0 ? (
          <List disablePadding>
            {searchTerms.map((term, index) => (
              <ListItem key={index} disablePadding sx={{ mb: 1.5 }}>
                <ListItemText
                  primary={term}
                  slotProps={{
                    primary: {
                      variant: "body1",
                      color: "text.secondary",
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          // Display a message if there are no search terms
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Typography color="text.secondary">No key terms found.</Typography>
          </Box>
        )}
      </Box>
    </SoothCard>
  );
}
